import { DropEvent, useDropzone } from 'react-dropzone';
import styled from 'styled-components';

import layout from '../../../../app/layout';

const ChangePic = styled.p`
  font-size: 11px;
  color: ${(props) => props.theme.primaryDarkerColor};
  padding-left: ${layout.spacing};
  margin: 0;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export type Props = {
  onDropAccepted: (files: File[], event: DropEvent) => void;
};

const UserImageDropzone = ({ onDropAccepted }: Props) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted,
    accept: 'image/jpeg, image/jpg, image/png, image/*',
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <ChangePic>Editar</ChangePic>
    </div>
  );
};

export default UserImageDropzone;
